import { SJT_SALES_ITEMS } from "./questionBank.js";

export const SJT_SALES_NORMS = {
  overall: { mean:38.4, sd:8.6, n:780 },
  by_sector: {
    bfsi:      { mean:39.8, sd:8.2 },
    pharma:    { mean:40.1, sd:7.9 },
    fmcg:      { mean:37.6, sd:8.8 },
    insurance: { mean:36.9, sd:9.1 },
    general:   { mean:38.4, sd:8.6 },
  }
};

export const SJT_SALES_BANDS = [
  { min:0,  max:20, label:"Developing",  color:"#dc2626", hire:"Not recommended for independent sales roles without intensive coaching." },
  { min:20, max:40, label:"Average",     color:"#d97706", hire:"Entry-level sales with structured onboarding and coaching." },
  { min:40, max:70, label:"Strong",      color:"#0891b2", hire:"Recommended. Demonstrates sound sales judgement and client focus." },
  { min:70, max:100,label:"Exceptional", color:"#059669", hire:"Strongly recommended. High-calibre sales professional profile." },
];

export const SJT_SALES_DIMENSIONS = [
  { id:"objections",   label:"Objection Handling",     icon:"🛡",  items:[0,1,2,3]     },
  { id:"pipeline",     label:"Pipeline Management",     icon:"📈",  items:[4,5,6,7]     },
  { id:"trust",        label:"Client Trust & Relationships", icon:"🤝", items:[8,9,10,11] },
  { id:"negotiation",  label:"Negotiation",             icon:"⚡",  items:[12,13,14]    },
  { id:"resilience",   label:"Resilience & Sales Mindset", icon:"💪", items:[15,16,17]  },
  { id:"ethics",       label:"Ethics & Compliance",     icon:"⚖️",  items:[18,19]       },
];

export function scoreSJT_SALES(mostAnswers, leastAnswers) {
  let totalScore = 0;
  const itemScores = [];
  SJT_SALES_ITEMS.forEach((item, i) => {
    let s = 0;
    if (mostAnswers[i]  === item.most)  s += 2;
    if (leastAnswers[i] === item.least) s += 1;
    totalScore += s;
    itemScores.push(s);
  });
  const maxScore = SJT_SALES_ITEMS.length * 3; // 60
  const norm = SJT_SALES_NORMS.overall;
  const z = (totalScore - norm.mean) / norm.sd;
  const percentile = Math.min(99, Math.max(1, Math.round(50 + z * 17)));
  const band = SJT_SALES_BANDS.find(b => percentile >= b.min && percentile < b.max) || SJT_SALES_BANDS[0];
  const dimScores = {};
  SJT_SALES_DIMENSIONS.forEach(dim => {
    const dimTotal = dim.items.reduce((sum, idx) => sum + (itemScores[idx] || 0), 0);
    const dimMax   = dim.items.length * 3;
    dimScores[dim.id] = { score:dimTotal, max:dimMax, pct:Math.round((dimTotal/dimMax)*100), label:dim.label, icon:dim.icon };
  });
  return { totalScore, maxScore, rawPct:Math.round((totalScore/maxScore)*100), percentile, band, itemScores, dimScores, scales:{ sjt_sales:percentile } };
}
